export enum VerificationMode  {
    CHANGE_PRIMARY_EMAIL = 'changeEmail',
    CHANGE_SECONDARY_EMAIL = 'changeSecondaryEmail',
    CHANGE_PASSWORD = 'changePassword',
    REGISTER = 'register'
}